import React from "react";

const LoaderComponent = (props: any) => (
  <span>Loading...</span>
);

export default LoaderComponent;
